import React from 'react'
import { Link } from 'react-router-dom'

function AboutClosingCta() {
    return (
        <div className="cta-techdigit about-closing-cta td-section td-section--cta rts-callto-acation-area rts-callto-acation-area4 rts-section-gap">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="cta-techdigit-inner text-center">
                            <h2 className="title">Want to Know If We&apos;re the Right Fit?</h2>
                            <p className="cta-desc">
                                The first conversation costs nothing. We&apos;ll listen to what you&apos;re dealing with,
                                tell you honestly whether we think we can help—and, if we&apos;re not the right fit,
                                we&apos;ll tell you that too.
                            </p>
                            <p className="cta-sub">
                                No pressure. No pitch deck. Just a straight conversation.
                            </p>
                            <Link to="/contactus" className="rts-btn btn-primary-5 six">
                                Schedule Your Free Consultation
                            </Link>
                            <div className="cta-contact mt-4">
                                <a href="mailto:info@techdigitsolutions.com">info@techdigitsolutions.com</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutClosingCta
